<template lang="pug">
div#app
  .container
    b-navbar(toggleable='md' v-if='navbarEnabled').box-shadow.bg-white.rounded.mt-4
      b-navbar-toggle(target='nav_collapse')
      b-collapse(is-nav id='nav_collapse')

        // Navigation
        b-navbar-nav.mr-auto
          b-nav-item(to='/admin/dashboard', v-if="userRole === 'admin'")
            font-awesome-icon(icon='chart-line').mr-2
            | Ülevaade
          b-nav-item(to='/admin/signatures', v-if="userRole === 'admin'")
            font-awesome-icon(icon='file-signature').mr-2
            | Allkirjad
          b-nav-item(to='/admin/donations', v-if="userRole === 'admin'")
            font-awesome-icon(icon='hand-holding-heart').mr-2
            | Annetused
          b-nav-item(to='/admin/newsletter-signups', v-if="userRole === 'admin'")
            font-awesome-icon(icon='envelope').mr-2
            | Uudiskirjaga liitumised
          b-nav-item(to='/admin/export', v-if="userRole === 'admin'")
            font-awesome-icon(icon='download').mr-2
            | Väljavõtted
          b-nav-item(to='/admin/urls').mr-2
            font-awesome-icon(icon='hand-pointer').mr-2
            | Lühiaadressid
          b-nav-item(to='/admin/campaign-configuration', v-if="userRole === 'admin'").mr-2
            font-awesome-icon(icon='cog').mr-2
            | Sätted

        // Right side buttons
        b-navbar-nav
          b-button(variant='primary' @click='logout')
            font-awesome-icon(icon='sign-out-alt').mr-2
            | Välju
    router-view
</template>

<script>
import { getUserRole } from './auth/auth.util'

export default {
  mounted() {
    const someAdminPage = this.$route.path.indexOf('/admin') !== -1
    const probablyLoggedIn = window.localStorage.getItem('accessToken') !== null
    if (someAdminPage && !probablyLoggedIn) {
      this.$router.push('/admin/login')
    }
  },

  computed: {
    navbarEnabled() {
      const p = this.$route.path
      const probablyLoggedIn = window.localStorage.getItem('accessToken') !== null
      return probablyLoggedIn && (p.indexOf('/admin') !== -1) && (p !== '/admin/login')
    },
    userRole() {
      return getUserRole()
    }
  },

  methods: {
    logout() {
      window.localStorage.removeItem('accessToken')
      this.$router.push('/admin/login')
    },
    updateUserRole() {
      this.role = getUserRole()
    }
  },

  watch: {
    '$route.path': function() {
      this.updateUserRole()
    }
  }
}
</script>

<style lang="scss">
$theme-colors: (
  "primary": #179d94
);
@import "~bootstrap/scss/bootstrap";

html, body {
  height: 100%;
}

#app {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  color: #363636;
  background: url('./assets/bg.jpg') no-repeat center center fixed;
  background-size: cover;
  min-height: 100%;
  overflow: hidden;
}

.container {
  @include media-breakpoint-up(sm) {
    max-width: 1600px;
  }
}

.navbar {
  display: inline-block;
  width: 100%;
}

.box-shadow {
  box-shadow: rgba(0, 0, 0, .5) 0px 8px 16px 0px;
}

.box {
  @extend .bg-white;
  @extend .rounded;
  @extend .box-shadow;
  padding: 15px;

  h2 {
    font-size: 1.5rem;
    font-weight: 700;
    margin-top: 0.3rem;
    margin-bottom: 1rem;
  }

  h4 {
    font-weight: 700;
  }
}

.nav-link {
  outline: none;
}

.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  box-shadow: rgba(0, 0, 0, .5) 0px 14px 30px 0px;
}
</style>
